// extracted by mini-css-extract-plugin
module.exports = {"page":"HU","account":"IU","pdp":"JU","cart":"KU","brand":"LU","cartModal":"MU","checkout":"NU"};